import React from "react";
import { Form, Input } from "antd";
import FormItem from "components/fields/FormItem";
import { requiredField } from "utils/crudSagaHelper";

const { TextArea } = Input;

export default function LeaveApprovalForm({ leaveType, days, action }) {
  const formattedLeaveType = leaveType
    ?.toLowerCase()
    .replace(/\s+/g, "-");

  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-2 gap-4">
        <div className="flex flex-col gap-1">
          <p className="text-sm text-gray-500">Leave Type</p>
          <span className={`text-xs status-indicator ${formattedLeaveType}`}>
            {leaveType}
          </span>
        </div>

        <div className="flex flex-col gap-1">
          <p className="text-sm text-gray-500">Duration</p>
          <span className="text-[13px] font-medium">
            {days} day{days > 1 ? "s" : ""}
          </span>
        </div>
      </div>

      <Form
        layout="vertical"
      >
        <FormItem
            className="font-medium mb-0"
            name="notes"
            label={action === "Reject" ? "Reason for Rejection" : "Additional Notes (Optional)"}
            rules={
                action === "Reject"
                ? [{ required: true, message: "Please provide a reason for rejection." }]
                : []
            }
            >
            <TextArea
                id="notes"
                className="input-field"
                maxLength={255}
                placeholder={
                action === "Reject"
                    ? "Provide a reason for rejecting this request..."
                    : "Add any additional notes..."
                }
            />
        </FormItem>
      </Form>
    </div>
  );
}
